import React from 'react';
import PropTypes from 'prop-types';
import {Toggle} from '@/components/atoms';
import {awardPointsToggleSchema, joinPerfectStoreToggleSchema} from './schemas';

const AdditionalOptionsSection = ({formData, onChange, isPepIris = false}) => {
  const handleAwardPointsToggleChange = (val) => {
    const updates = {
      ...formData,
      awardPointsWhenTargetMet: val
    };
    if (val) {
      updates.rewardDate = '';
      updates.rewardDateValid = undefined;
    }
    onChange(updates);
  };

  return (
    <div
      className='filters-partners'
      data-testid='perfect-store-additional-options'>
      <div className='flex flex-row flex-wrap gap-6'>
        <Toggle
          value={!!formData?.requiredUserToJoin}
          updateValue={(val) =>
            onChange({...formData, requiredUserToJoin: val})
          }
          uiSchema={joinPerfectStoreToggleSchema}
          id='join-perfect-store'
        />
        {isPepIris && (
          <Toggle
            value={!!formData?.awardPointsWhenTargetMet}
            updateValue={handleAwardPointsToggleChange}
            uiSchema={awardPointsToggleSchema}
            id='award-points-when-met'
          />
        )}
      </div>
    </div>
  );
};

AdditionalOptionsSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  isPepIris: PropTypes.bool
};

export default React.memo(AdditionalOptionsSection);
